export default __webpack_public_path__ + "static/media/shoes6.fcc1548c.jpeg";